export default "__VITE_ASSET__CxRvWRqO__"